import { Viewer } from '@react-pdf-viewer/core';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import '@react-pdf-viewer/core/lib/styles/index.css';

interface ModalExampleProps {
    fileUrl: string;
    title: string;
}

const ModalView: React.FC<ModalExampleProps> = ({ fileUrl, title }) => {
    const [shown, setShown] = useState(false);

    // Handle closing modal on 'Esc' key press
    useEffect(() => {
        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setShown(false);
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, []);

    const openModal = () => {
        setShown(true);
    };

    const modalBody = () => (
        <div
            style={{
                backgroundColor: '#fff',
                flexDirection: 'column',
                overflow: 'hidden',

                /* Fixed position */
                left: 0,
                position: 'fixed',
                top: 0,

                /* Take full size */
                height: '100%',
                width: '100%',

                /* Displayed on top of other elements */
                zIndex: 9999
            }}
        >
            <div
                style={{
                    alignItems: 'center',
                    backgroundColor: '#000',
                    color: '#fff',
                    display: 'flex',
                    padding: '.5rem'
                }}
            >
                <div style={{ marginRight: 'auto' }}>{title} </div>
                <button
                    style={{
                        backgroundColor: '#357edd',
                        border: 'none',
                        borderRadius: '4px',
                        color: '#ffffff',
                        cursor: 'pointer',
                        padding: '8px'
                    }}
                    onClick={() => setShown(false)}
                >
                    Close
                </button>
            </div>
            <div
                style={{
                    flexGrow: 1,
                    overflow: 'auto',
                    height: '99%'
                }}
            >
                <Viewer
                    fileUrl={fileUrl}
                    renderPage={(props) => (
                        <div>
                            {/* Use the default rendering, this seems fixed duplidated key warning */}
                            {props.canvasLayer.children}
                            {/* Render the text layer for selectable/searchable text */}
                            {props.textLayer && props.textLayer.children}
                            {/* Render the annotation layer for links, highlights, etc. looks like this is the problem causing duplicated key */}
                        </div>
                    )}
                />
            </div>
        </div>
    );

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <button
                    style={{
                        backgroundColor: '#00449e',
                        border: 'none',
                        borderRadius: '.25rem',
                        color: '#fff',
                        cursor: 'pointer',
                        padding: '.5rem',
                        width: 'auto',
                        minWidth: '120px',
                        whiteSpace: 'nowrap'
                    }}
                    onClick={openModal}
                >
                    View Document
                </button>
                {shown && ReactDOM.createPortal(modalBody(), document.body)}
            </div>
        </>
    );
};

export default ModalView;
